import { useContext } from 'react'
import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import AwesomeError from 'components/Common/AwesomeError'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import BodyText from 'LuxKit/Typography/BodyText'
import ContactContext from 'contexts/contactContext'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import TextLink from 'LuxKit/TextLink'

interface Props {
  className?: string
  canSwitchToHotel?: boolean
}

function OfferCalendarNoFlightsMessage(props: Props) {
  const intl = useIntl()
  const dispatch = useOfferPageDispatch()
  const currentContact = useContext(ContactContext)

  const noFlightsTitle = intl.formatMessage({
    id: 'DmDhpHcAECrV_L73E-_1',
    defaultMessage: 'No flights available',
  })

  const viewHotelOnlyLabel = intl.formatMessage({
    id: 'ut3ZuYE2UJsvVgYVQXwz',
    defaultMessage: 'View hotel only prices',
  })

  const onClick = () => {
    dispatch({ type: OfferPageActions.setFlights, flights: false })
  }

  return (
    <AwesomeError title={noFlightsTitle} className={props.className}>
      <VerticalSpacer gap={32}>
        <BodyText variant="large">
          <FormattedMessage
            id="b0wxzpfxsMbTaRMAaMnL"
            defaultMessage="Unfortunately we couldn’t find any flights for the travel dates you selected. Try selecting new travel dates or give our flights team a call on <phoneLink>{phoneNumber}</phoneLink>"
            
            values={{
              phoneNumber: currentContact.local.humanReadable,
              phoneLink: (chunks: React.ReactNode) => (
                <div>
                  <TextLink
                    href={`tel:${currentContact.local.number}`}
                    rel="nofollow"
                    wrap="no-wrap"
                  >
                    {chunks}
                  </TextLink>
                </div>
              ),
            }}
          />
        </BodyText>
        {props.canSwitchToHotel && <TextButton kind="primary" onClick={onClick}>
          {viewHotelOnlyLabel}
        </TextButton>}
      </VerticalSpacer>
    </AwesomeError>
  )
}

export default React.memo(OfferCalendarNoFlightsMessage)
